export default {
  publish: 'Опубликовать',
  unpublish: 'Снять с публикации',
  publishAnyway: 'Всё равно опубликовать',
  cancel: 'Отмена',
  warningsTitle: 'Предупреждения публикации',
  noWarnings: 'Предупреждений нет. Готово к публикации.',
  confirmPublish: 'Опубликовать этот конфигуратор?',
  preview: {
    plural: 'Превью',
    variant: 'Вариант',
    slots: 'Слоты',
    zones: 'Зоны',
    allowedParts: 'Допустимые части',
    allowedMaterials: 'Допустимые материалы',
    default: 'по умолчанию',
    empty: 'Данных для превью пока нет',
    noVariants: 'У этого конфигуратора нет вариантов',
    model: '3D-модель',
    noModel: 'Нет 3D-модели для этого варианта',
    playerLoadFailed: 'Не удалось загрузить плеер конфигуратора',
    controlsTitle: 'Конфигурация',
    partsLoading: 'загружаются детали…',
    partsFailed: 'Часть деталей не загрузилась — их нет в сцене',
    noControls: 'В этом варианте нечего настраивать',
    noCandidatesForSlot: 'Для этого слота нет деталей',
    options: 'Опции'
  }
};
